import { render, staticRenderFns } from "./reverificate.vue?vue&type=template&id=8de3a782&scoped=true"
import script from "./reverificate.vue?vue&type=script&lang=js"
export * from "./reverificate.vue?vue&type=script&lang=js"
import style0 from "./reverificate.vue?vue&type=style&index=0&id=8de3a782&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de3a782",
  null
  
)

export default component.exports